<template>
  <div class="trips-page">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK
    </div>

    <div class="product-header">
      <img :src="tripData.details.ProductImage" class="product-image">
      <div class="product-info">
        <div class="pd-title">{{ tripData.details.ProductName }}</div>
        <div class="product-meta">
          <span v-if="tripData.details.Duration">
            <i class="far fa-clock fa-fw"></i>
            {{ tripData.details.Duration }}
          </span>
          <span v-if="tripData.details.ProductCode">
            <i class="fas fa-tags fa-fw"></i>
            Product: {{ tripData.details.ProductCode }}
          </span>
        </div>
        <p class="desc">{{ cleanTags(view.Description) }}</p>
      </div>
    </div>

    <div class="section-title">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path></svg>
      Choose Your Experience
    </div>

    <div class="ticket-card" v-for="ticket in tripData.list">
      <div class="ticket-header">
        <div class="ticket-title-wrap">
          <div class="ticket-title">{{ ticket.gradeTitle }}</div>
          <div class="ticket-subtitle">{{ ticket.gradeDescription }}</div>
        </div>
        <div class="ticket-price">
          <div class="label">Total Price</div>
          <div class="amount">
            <span class="currency">{{ currencySymbol[currency.code] }}</span>
            {{ applyCurrency(ticket.Price, false) }}
          </div>
          <div class="per">for {{ ticket.TotalPax }} travelers</div>
        </div>
      </div>
      <div class="ticket-details">
        <div class="ticket-detail">
          <i class="far fa-calendar fa-fw"></i>
          {{ formatDate(ticket.bookingDate) }}
        </div>
        <div class="ticket-detail">
          <i class="fas fa-users fa-fw"></i>
          {{ ticket.TotalPax }} 
        </div>
        <div class="ticket-detail" v-if="ticket.available">
          <i class="far fa-check-circle fa-fw"></i>
          <span class="available">Available</span>
        </div>
        <div class="ticket-detail" v-if="ticket.langServices && ticket.langServices.length">
          <i class="fas fa-globe fa-fw"></i>
          {{ ticket.langServices[0] }}{{ ticket.langServices.length > 1 ? '+' : '' }}
        </div>
      </div>
      <div class="ticket-footer" v-if="ticket.ageBandsRequired && ticket.ageBandsRequired.length">
        <div class="ticket-pax">Min: <strong>{{ ticket.ageBandsRequired[0][0].minimumCountRequired }}</strong> • Max: <strong>{{ ticket.ageBandsRequired[0][0].maximumCountRequired }}</strong> per booking</div>
        <button class="ticket-btn" @click="getBlockData(ticket)">Select</button>
      </div>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
import currencySymbol from '@/data/currency.js'
import xcurrency from '@/modules/api/currency'
import moment from 'moment-timezone'

export default {
  name: 'traveller-modal',
  data () {
    return {
      currencySymbol: currencySymbol
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    travellers () { return this.booking.filters.travellers },
    sightSeeing () { return this.$store.state.sightSeeing },
    view () { return this.sightSeeing.view },
    tripData () { return this.sightSeeing.trips },
    locationLabel () {
      if (!this.sightSeeing.location.selected) return ''
      return `${this.sightSeeing.location.selected.destinationName}, ${this.sightSeeing.location.selected.countryName}`
    },
    show: {
      get () { return this.tripData.show },
      set (x) { this.$store.commit('sightSeeing/setTripsData', {show: x}) }
    },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    back () {
      this.$router.push('/sight-seeing/view')
    },
    cleanTags (x) {
      let parser = new DOMParser()
      return parser.parseFromString(x, 'text/html').body.textContent
    },
    price (data) {
      let price = data.TotalDisplayFare / this.currency.list[data.Currency]
      return price.toFixed(2)
    },
    applyCurrency (data, useSymbol = true, noComma = false) {
      let x = data.TotalDisplayFare
      if (data.Currency !== 'USD' && this.currency.code !== data.Currency) {
        x = x / this.currency.list[data.Currency]
        x = x.toString().replace(/[',']/g, '')
        x = parseFloat(x)
        x = x * this.currency.value
      }
      return xcurrency.format({
        code: data.Currency,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    },
    formatDate (x) {
      if (!x) return ''
      return moment(x, 'YYYY-MM-DD').format('MMMM DD, YYYY')
    },
    getBlockData (trip) {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})

      let ageBands = [{bandId: 'ADT', count: this.travellers.adult}]
      if (self.children) ageBands.push({bandId: 'CHD', count: this.travellers.children})

      self.$sdk.post2(`${CONFIG.d2dAPI}/sightseeing/provider1/block-trip`, {
        ProductCode: trip.ProductCode,
        GradeCode: trip.gradeCode,
        BookingDate: moment(self.sightSeeing.date.start, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        ResultToken: trip.TourUniqueId,
        ageBands: ageBands
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (!r.Status) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.Message
          })
          return
        }
        self.$store.commit('sightSeeing/setTripsData', {selected: trip})
        self.$store.commit('sightSeeing/setData', {block: r.BlockTrip.BlockTripResult})
        if (!self.$store.state.user.token) {
          self.$store.commit('global/setAuthData', {
            show: true,
            action: '/sight-seeing/review'
          })
          return
        }
        self.$router.push('/sight-seeing/review')
      })
    }
  },
  mounted () {
    if (!this.view) {
      this.$router.push('/search')
      return
    }
  }
}
</script>

<style lang="scss" scoped>
.trips-page{
  padding: 15px 20px;
  margin-bottom: 20px;
  min-height: calc(100vh - 60px);
}
.back-box{
  color: #4a4a6a;
  letter-spacing: .7px;
  margin-bottom: 10px;
  cursor: pointer;
  
  &:hover{
    color: #ff9c09;
  }
}

.product-header {
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
  align-items: flex-start;
}
.product-image {
  width: 180px;
  height: 180px;
  border-radius: 16px;
  object-fit: cover;
  flex-shrink: 0;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
.product-info {
  flex: 1;

  .pd-title{
    font-size: 26px;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 8px;
    line-height: 1.3;
  }
}
.product-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;

  span{
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    color: #8892a0;
    font-weight: 500;

    i{
      color: #ECAE20;
    }
  }
}
.product-info .desc {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px;

  svg{
    width: 22px;
    height: 22px;
    color: #ECAE20;
  }
}
.ticket-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 2px solid transparent;
  transition: all 0.25s;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  &:hover{
    border-color: #ECAE20;
    box-shadow: 0 8px 28px rgba(236, 174, 32, 0.12);
  }
}
.ticket-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
}
.ticket-title-wrap {
  flex: 1;
}
.ticket-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 4px;
}
.ticket-subtitle {
  font-size: 13px;
  color: #8892a0;
  font-weight: 500;
}
.ticket-price {
  text-align: right;
  flex-shrink: 0;

  .label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #b0b8c4;
    margin-bottom: 2px;
  }
  .amount {
    font-size: 26px;
    font-weight: 700;
    color: #1a1a2e;
  }
  .per {
    font-size: 12px;
    color: #b0b8c4;
  }
}
.ticket-details {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 14px 0;
  border-top: 1px solid #f1f3f6;
  border-bottom: 1px solid #f1f3f6;
  margin-bottom: 16px;
}
.ticket-detail {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;

  i{
    color: #ECAE20;
  }
  .available {
    color: #22c55e;
    font-weight: 600;
  }
}
.ticket-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ticket-pax {
  font-size: 13px;
  color: #8892a0;
  font-weight: 500;
  word-spacing: 2px;

  strong {
    color: #1a1a2e;
  }
}
.ticket-btn {
  padding: 10px 24px;
  background: #ECAE20;
  color: #1a1a2e;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}
</style>



// WEBPACK FOOTER //
// index.vue?3fdd172c